export { BYLINE_METRIC, CONTENT_TITLE_METRIC } from '../src/perf.config';
